module.exports = require("@cimpress/react-components/lib/Alert");